import React, { useEffect } from "react";

import { useDispatch, useSelector } from 'react-redux';
import { Colour, GroupandPartyWiseSummery } from '../../../Redux/Slice/login/loginSlice';
import { FinishMeterSummery, GreyDashboardData, GrayDashBoardchart2, GrayDashBoardchart1, resetFinishMeterSummery } from '../../../Redux/Slice/Grey/GreyDashboard/GreyDashboardSlice';
import Cookies from "js-cookie";
import { Row, Col, Form, Button } from "react-bootstrap";
import GreyTable from '../../../components/Tables/GreyTable';
import Chart from '../../../components/Charts/Chart'
import { FaChevronDown } from "react-icons/fa";
import { useState } from "react";
import { Loader } from '../../../components/Loader/Loader';
import { useNavigate } from "react-router-dom";
import DroupdownFilterBox from '../../../components/FilterBox/DroupdownFilterBox';
import { useTheme } from "../../../Themecontext/Themecontext";
import Demo from '../Demo/Demo';

export const Dashboard = ({ sidebarOpen }) => {

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const FinancialYear = Cookies.get("FinancialYear");

  const { mainFilterData, DataMain } = useSelector((state) => state.ClientLogin);
  const { FinishMeterSummerydata, greydata, chart2data, chart1data } = useSelector((state) => state.GreyDashboardSlice);

  const matchedFinancialYear = DataMain?.AC_Year_List?.find(
    (item) => item.AcYearID === Number(FinancialYear)
  );

  const formattedFinancialYear = matchedFinancialYear?.AcYear
    ? (() => {
      const [start, end] = matchedFinancialYear.AcYear.split(" - ");

      const startYear = start.split("/")[2];
      const endYear = end.split("/")[2].slice(-2);

      return `${startYear}-${endYear}`;
    })()
    : "";


  useEffect(() => {
    dispatch(FinishMeterSummery({}));
    dispatch(GreyDashboardData({}));
    dispatch(GrayDashBoardchart1({}))
    dispatch(GrayDashBoardchart2({}))
  }, [dispatch]);


  const { Colourdata } = useSelector((state) => state.ClientLogin);

  const iscolour = Colourdata?.data?.find((el) => el.ExeName === "GRAYNEW");
  const iscolourDark = Colourdata?.data?.find(
    (el) => el.ExeName === "GRAYDARKNEW"
  );

  const { theme } = useTheme();
  const isdark = theme;

  const [selectedProduction, setSelectedProduction] = useState("");
  const [selectedProductionId, setSelectedProductionId] = useState(null);

  const [selectedAccount, setSelectedAccount] = useState("");
  const [selectedAccountId, setSelectedAccountId] = useState(null);

  const [hoveredIndex, setHoveredIndex] = useState(null);


  const handleSubmit = (() => {
    dispatch(resetFinishMeterSummery())

    dispatch(FinishMeterSummery({
      ProductionGroupMstIDs: (selectedProductionId || "").toString(),
      AcIDs: (selectedAccountId || "").toString()
    }))

  })

const tableDataToDisplay =
    FinishMeterSummerydata?.data
      ?.slice() 
      .reverse()
      .map((row) => ({
        MonthName: row.MonthName,
        inwOpMeter: row.inwOpMeter,
        inwMeter: row.inwMeter,
        AprFinMtr: row.AprFinMtr,
        MayFinMtr: row.MayFinMtr,
        JunFinMtr: row.JunFinMtr,
        JulFinMtr: row.JulFinMtr,
        AugFinMtr: row.AugFinMtr,
        SepFinMtr: row.SepFinMtr,
        OctFinMtr: row.OctFinMtr,
        NovFinMtr: row.NovFinMtr,
        DecMtr: row.DecMtr,
        JanFinMtr: row.JanFinMtr,
        FebFinMtr: row.FebFinMtr,
        MarFinMtr: row.MarFinMtr,
        FinMtr: row.FinMtr,
        Shortage: row.Shortage,
        TotalOut: row.TotalOut,
        NewBal: row.NewBal,
        // readings: [
        //   row.AprFinMtr,
        //   row.MayFinMtr,
        //   row.JunFinMtr,
        //   row.JulFinMtr,
        //   row.AugFinMtr,
        //   row.SepFinMtr,
        //   row.OctFinMtr,
        //   row.NovFinMtr,
        //   row.DecMtr,
        //   row.JanFinMtr,
        //   row.FebFinMtr,
        //   row.MarFinMtr,
        // ],
      })) || [];

  const columns = [
    { label: "Charts", key: "charts" },
    { label: "Sr No.", key: "srNumber", align: "center", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2 },
    { label: "Month Name", key: "MonthName", align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2 },
    {
      label: "Opening Meter",
      key: "inwOpMeter",
      align: "right",
      format: true,
      colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5
    },
    {
      label: "Inward Meter",
      key: "inwMeter",
      align: "right",
      format: true,
      colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5
    },
    { label: "Finish Total", key: "FinMtr", align: "right", format: true, colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5 },
    { label: "Total Shortage", key: "Shortage", align: "right", format: true, colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5 },
    { label: "Total Out", key: "TotalOut", align: "right", format: true, colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5 },
    { label: "New Balance", key: "NewBal", align: "right", format: true, colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5 },
    {
      label: "Apr",
      key: "AprFinMtr",
      align: "right",
      format: true,
      colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5
    },
    {
      label: "May",
      key: "MayFinMtr",
      align: "right",
      format: true,
      colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5
    },
    {
      label: "Jun",
      key: "JunFinMtr",
      align: "right",
      format: true,
      colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5
    },
    {
      label: "Jul",
      key: "JulFinMtr",
      align: "right",
      format: true,
      colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5
    },
    {
      label: "Aug",
      key: "AugFinMtr",
      align: "right",
      format: true,
      colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5
    },
    {
      label: "Sep",
      key: "SepFinMtr",
      align: "right",
      format: true,
      colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5
    },
    {
      label: "Oct",
      key: "OctFinMtr",
      align: "right",
      format: true,
      colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5
    },
    {
      label: "Nov",
      key: "NovFinMtr",
      align: "right",
      format: true,
      colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5
    },
    {
      label: "Dec",
      key: "DecMtr",
      align: "right",
      format: true,
      colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5
    },
    {
      label: "Jan",
      key: "JanFinMtr",
      align: "right",
      format: true,
      colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5
    },
    {
      label: "Feb",
      key: "FebFinMtr",
      align: "right",
      format: true,
      colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5
    },
    {
      label: "Mar", key: "MarFinMtr", align: "right", format: true,
      colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5
    },

  ];


  const tableData1 = (chart1data?.inward || []).map(
    (row, index, arr) => ({
      srNumber: (index + 1),
      MonthName: row.MonthName,
      InwMeter: row.InwMeter,
    })
  );



  const columns1 = [
    { label: "Sr No.", key: "srNumber", align: "center", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2 },
    { label: "Month Name", key: "MonthName", align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2 },
    { label: `Inw Meter ${formattedFinancialYear}`, key: "InwMeter", align: "right", format: true, colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5 },

  ];

  const chartData1 = (chart1data?.inward || []).map((row) => ({
    month: row.MonthName,
    value: row.InwMeter
  }));

  const chartData2 = (chart1data?.inward || []).map((row) => ({
    month: row.MonthName,
    value: row.InwMeter
  }));

  const tableData2 = (chart2data?.inward || []).map((row, index) => ({
    srNumber: index + 1,
    MonthName: row.MonthName,
    FinishMeter: row.FinishMeter,
    NetAmount: row.NetAmount,
  }));

  const columns2 = [
    {
      label: "Sr No.",
      key: "srNumber",
      align: "center",
      colors:
        isdark === "light"
          ? iscolour?.Colour2
          : iscolourDark?.Colour2,
    },
    {
      label: "Month Name",
      key: "MonthName",
      align: "left",
      colors:
        isdark === "light"
          ? iscolour?.Colour2
          : iscolourDark?.Colour2,
    },
    {
      label: `FinishMeter ${formattedFinancialYear} `,
      key: "FinishMeter",
      align: "right",
      format: true,
      colors:
        isdark === "light"
          ? iscolour?.Colour1
          : iscolourDark?.Colour5,
    },
    { label: "Taxable Amount", key: "NetAmount", align: "right", format: true, colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5 },
  ];


  const formatYearRange = (yearRange) => {
    const [startYear, endYear] = yearRange.split(" - ");
    const start = startYear.split("/")[2];
    const end = endYear.split("/")[2];
    return `${start}/${end.slice(2)}`;
  };

  const formatAsINR = (value, options = {}) => {
    return new Intl.NumberFormat("en-IN", {
      currency: "INR",
      maximumFractionDigits: 0,
      minimumFractionDigits: 0,
      ...options,
    }).format(value);
  };

  const cards = [
    {
      title: "Opening",
      url: "/opening",
      date: greydata?.inward
        ?.map(
          (el) =>
            `${formatYearRange(el.FAcYear)} - ${formatAsINR(el.OpInwMeter)}`
        )
        .join("\n"),
    },
    {
      title: "Inward",
      url: "/Inward",
      date: greydata?.inward
        ?.map(
          (el) => `${formatYearRange(el.FAcYear)} - ${formatAsINR(el.InwMeter)}`
        )
        .join("\n"),
    },
    {
      title: "Delivery",
      url: "/Delivery",
      date: chart2data?.Year?.map(
        (el) =>
          `${formatYearRange(el.FAcYear)} - ${formatAsINR(el.FinishMeter)}`
      ).join("\n"),
    },
    {
      title: "Balance",
      url: "/Balance",
      date: greydata?.inward
        ?.map(
          (el) => `${formatYearRange(el.FAcYear)} - ${formatAsINR(el.BalMeter)}`
        )
        .join("\n"),
    },
  ];

  if (
    !FinishMeterSummerydata ||
    !chart1data ||
    !chart2data ||
    !greydata
  ) {
    return <Loader />;
  } else {
    return (
      <>
        <style>
{`
.custom-scroll::-webkit-scrollbar {
  width: 6px;
}

.custom-scroll::-webkit-scrollbar-track {
 background: var(--theme-scrollbar-track, ${isdark === "light" ? iscolour?.Colour12 : iscolourDark?.Colour6});
              
}

.custom-scroll::-webkit-scrollbar-thumb {
    background: var(--theme-scrollbar-thumb, ${isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour1});
                color: ${isdark === "light" ? iscolour?.Colour5 : iscolourDark?.Colour8};
}

.custom-scroll::-webkit-scrollbar-thumb:hover {
  background: var(--theme-scrollbar-thumb-hover, ${isdark === "light" ? iscolour?.Colour4 : iscolourDark?.Colour1});
}
`}
        </style>


        <div className='pageContainer'>
          <div
            style={{
              boxShadow: "0px 7px 12px rgba(0,0,0,0.27)",
              borderRadius: "12px"
            }}
          >
            <div
              className="px-3 px-sm-4 py-3"
              style={{
                backgroundColor: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour1,
                borderRadius: "12px 12px 0px 0px",
              }}
            >
              <Row className="mb-3">
                <Col>
                  <p style={{
                    fontSize: "18px",
                    fontWeight: "700",
                    color: isdark === "light" ? iscolour?.Colour5 : iscolourDark?.Colour8,

                  }}>GREY BALANCE METER </p>
                </Col>
              </Row>

              {/* Dropdowns */}
              <Row className="g-3 align-items-end">

                {/* prodution Name */}
                <Col lg={6} md={6} sm={12} className="m-0">
                  <DroupdownFilterBox
                    label="Production Name"
                    data={mainFilterData?.production_Group_Master_List?.map((item) => ({
                      label: item.ProductionGroupMstName,
                      value: item.ProductionGroupMstID,
                    }))}
                    selectedValue={selectedProduction}
                    setSelectedValue={setSelectedProduction}
                    selectedId={selectedProductionId}
                    setSelectedId={setSelectedProductionId}
                    placeholder="Select Production Group(s)"
                    isdark={isdark}
                    iscolour={iscolour}
                    iscolourDark={iscolourDark}
                    isMulti={false}
                  />
                </Col>

                {/* Party Name */}
                <Col lg={6} md={6} sm={12} className="m-0">
                  <DroupdownFilterBox
                    label="Account Name"
                    data={mainFilterData?.account_list?.map((item) => ({
                      label: item.AcName,
                      value: item.AcID,
                    }))}
                    selectedValue={selectedAccount}
                    setSelectedValue={setSelectedAccount}
                    selectedId={selectedAccountId}
                    setSelectedId={setSelectedAccountId}
                    placeholder="Select Account Name(s)"
                    isdark={isdark}
                    iscolour={iscolour}
                    iscolourDark={iscolourDark}
                    isMulti={false}
                  />
                </Col>

                {/* Submit Button */}
                <Col xs={12}>
                  <Button
                    className="hover-scale-btn"
                    style={{
                      width: "100%",
                      background: isdark === "light" ? iscolour?.Colour5 : iscolourDark?.Colour8,
                      color: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour1,
                      border: "none",
                      padding: "12px",
                      borderRadius: "12px",
                      // color: "#0f3d2e",
                      fontWeight: "700"
                    }}
                    onClick={handleSubmit}
                  >
                    Apply Filter
                  </Button>
                </Col>

              </Row>
            </div>

            <div
              style={{
                borderRadius: "0px 0px 16px 16px",
                overflow: "hidden"
              }}
            >
              <Row className="pt-2">
                <Col>
                  <div
                    style={{
                      background: isdark === "light"
                        ? iscolour?.Colour4
                        : iscolourDark?.Colour4
                    }}
                  >
                    <GreyTable
                      columns={columns}
                      data={tableDataToDisplay}
                      iscolourDark={iscolourDark}
                      iscolour={iscolour}
                    />
                  </div>
                </Col>
              </Row>
            </div>
          </div>



          <div className='pt-4'>

            <Row className="g-4">

              {cards.map((item, index) => (
                <Col lg={3} md={6} sm={12} key={index}>

                  <div
                    style={{

                      backgroundColor: isdark === "light" ? iscolour?.Colour5 : iscolourDark?.Colour7,
                      borderRadius: "12px",
                      padding: "20px",
                      border: `2px solid ${isdark === "light" ? iscolour?.Colour4 : iscolourDark?.Colour3}`,
                      boxShadow: "0 4px 10px rgba(0,0,0,0.08)",
                      height: "100%"
                    }}
                  >
                    <p
                      style={{
                        fontSize: "14px",
                        fontWeight: "700",
                        marginBottom: "10px",
                        color: isdark === "light" ? iscolour?.Colour3 : iscolourDark?.Colour4,
                      }}
                    >
                      {item.title}
                    </p>

                    <p
                      style={{
                        fontSize: "18px",
                        fontWeight: "600",
                        marginBottom: "15px",
                        color: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2,

                      }}
                    >
                      {item.date}
                    </p>

                    <span
                      onClick={() => navigate(item.url)}
                      onMouseEnter={() => setHoveredIndex(index)}
                      onMouseLeave={() => setHoveredIndex(null)}
                      style={{
                        fontSize: "13px",
                        color: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour1,
                        cursor: "pointer",
                        fontWeight: "600",
                        display: "inline-flex",
                        alignItems: "center",
                        gap: "4px",
                      }}
                    >
                      <span
                        style={{
                          transition: "all 0.3s ease",
                          transform:
                            hoveredIndex === index
                              ? "translateY(-2px)"
                              : "translateY(0px)",
                          textDecoration:
                            hoveredIndex === index
                              ? "underline"
                              : "none",
                          textUnderlineOffset: "3px",
                        }}
                      >
                        View More
                      </span>

                      <span
                        style={{
                          display: "inline-block",
                          transition: "transform 0.3s ease",
                          transform:
                            hoveredIndex === index
                              ? "translateX(8px)"
                              : "translateX(0px)",
                        }}
                      >
                        →
                      </span>
                    </span>
                  </div>

                </Col>
              ))}

            </Row>
          </div>


          <div className='mt-4' style={{ boxShadow: "0px 7px 12px rgba(0,0,0,0.50)", borderRadius: " 12px" }}>

            <Row>
              <Col>
                <div style={{
                  fontSize: "18px",
                  fontWeight: "700",
                  backgroundColor: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour1,
                  color: isdark === "light" ? iscolour?.Colour5 : iscolourDark?.Colour8,
                  padding: "18px 25px",
                  borderRadius: " 12px 12px 0px 0px"
                }}>
                  <p className='m-0'>TOTAL INWARD METER</p>
                </div>
              </Col>
            </Row>
            <Row className='p-0 m-0' style={{
              backgroundColor: isdark === "light" ? iscolour?.Colour5 : iscolourDark?.Colour7,
              borderRadius: "0px 0px 16px 16px"
            }}>
              <Col lg={6} md={12} sm={12} className='pt-3 '>
                <div>
                  <GreyTable
                    columns={columns1}
                    data={tableData1}
                    iscolourDark={iscolourDark}
                    iscolour={iscolour}
                  />
                </div>
              </Col>
              <Col lg={6} md={12} sm={12} className='py-3 p-0'>
                <div>
                  <Chart data={chartData1} sidebarOpen={sidebarOpen} noWrapper={true} />
                </div>
              </Col>
            </Row>


          </div>

          <div className='mt-4' style={{ boxShadow: "0px 7px 12px rgba(0,0,0,0.50)", borderRadius: " 12px" }}>
            <Row>
              <Col>
                <div style={{
                  fontSize: "18px",
                  fontWeight: "700",
                  backgroundColor: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour1,
                  color: isdark === "light" ? iscolour?.Colour5 : iscolourDark?.Colour8,
                  padding: "18px 25px",
                  borderRadius: " 12px 12px 0px 0px"
                }}>
                  <p className='m-0'> TOTAL FINISH METER </p>
                </div>
              </Col>
            </Row>
            <Row className='p-0 m-0' style={{
              backgroundColor: isdark === "light" ? iscolour?.Colour5 : iscolourDark?.Colour7,
              borderRadius: "0px 0px 16px 16px"
            }}>
              <Col lg={6} md={12} sm={12} className='pt-3'>
                <div>
                  <GreyTable
                    columns={columns2}
                    data={tableData2}
                    iscolourDark={iscolourDark}
                    iscolour={iscolour}
                  />
                </div>
              </Col>
              <Col lg={6} md={12} sm={12} className='pt-3 p-0'>
                <div>
                  <Chart data={chartData2} noWrapper={true} />
                </div>
              </Col>
            </Row>


          </div>



        </div >
      </>
    )
  }
}

export default Dashboard
